import React from 'react';
import {Col, Container, Row} from "react-bootstrap";
import {Link} from 'gatsby';

function Solution(props) {
    return (
        <div className="services_solution  p-100">
            <Container>
                <Row>
                    <Col xs={12} md={6} lg={5} xl={5} xxl={5}>
                        <div className="example" data-text="Tech Stack">
                            <h2>AR/VR App Development Tech Stack</h2>
                        </div>
                    </Col>
                    <Col xs={12} md={6} lg={6} xl={6} xxl={6} className="offset-lg-1">
                        <p>Our Augmented And Virtual Reality Experts Trust These Tools And Technologies To Build Mixed
                            Reality Applications And Exceptional Experiences That Follow.
                        </p>
                        <p>
                            We use Swift, Objective-C, Xcode, Java, Kotlin, and Android SDK, as the preferred mobile
                            technologies, and Node.JS, Python, Django, PHP, MySQL, MongoDB, etc. for backend and
                            database.</p>
                        <p>Using one or more technologies as a suite depends on the type of business-level AR/VR
                            application, user education and engagement requirement, and collaborative measures to
                            connect customers, support remote workers, etc.</p>
                        <Link to="/contact"
                              className="border_btn" aria-label="TekRevol Contact">Let's Connect!</Link>
                    </Col>

                </Row>
            </Container>
        </div>
    );
}

export default Solution;